import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

// import themes, { THEME_TYPES } from '@Styles/Themes';

import {
  addEmptyChoiceResult,
  addEmptyResultProbabilityCondition,
  addEmptyResultRequiredItemsCondition,
} from '@Services/Editor';

import { ReactComponent as BranchSVG } from '@Assets/Svgs/ic_branch.svg';
import TX from '@Components/Common/Text';
import Button from '@Components/Common/Button';
import useContextMenu from '@Hooks/useContextMenu';
import { ContextMenu, Item } from '@Components/Common/ContextMenu';
// import WarningImage from '@Assets/Images/ic_warning.png';
import HoverComponent from '@Components/Common/HoverComponent';
import { CHOICE_RESULT_KEYS } from '@Services/Editor/Constants';

const AddingChoiceResultButton = ({ processId, choiceId, results }) => {
  const dispatch = useDispatch();
  // const [branch, setBranch] = useState('');
  // const theme = themes[THEME_TYPES.LIGHT];
  // const isNonEmptyChoiceResults = results.length > 0;
  const { isContextMenuVisible, handleShowContextMenuClick } = useContextMenu();
  const handleAddEmptyChoiceResultClick = useCallback(() => {
    // const maxNextProcessIdObject = results.reduce((maxObject, currentObject) => {
    //   if (currentObject.nextProcessId > (maxObject ? maxObject.nextProcessId : Number.MIN_SAFE_INTEGER)) {
    //     return currentObject;
    //   }
    //   return maxObject;
    // }, null);
    // const nextProcessIdValue = maxNextProcessIdObject ? maxNextProcessIdObject.nextProcessId + 1 : 0;

    dispatch(addEmptyChoiceResult({ processId, choiceId }));
  }, [dispatch, results]);

  const handleAddEmptyChoiceResultProbabilityClick = () => {
    // setBranch(CHOICE_RESULT_KEYS.PROBABILITY);
    handleAddEmptyChoiceResultClick();
    dispatch(addEmptyResultProbabilityCondition({ processId, choiceId, resultId: results.length }));
  };
  const handleAddEmptyChoiceResultRquiredItemsClick = () => {
    // setBranch(CHOICE_RESULT_KEYS.REQUIRED_ITEMS);
    handleAddEmptyChoiceResultClick();
    dispatch(addEmptyResultRequiredItemsCondition({ processId, choiceId, resultId: results.length }));
  };

  const isExistProb = Object.keys(results[0].resultPropertyChipState).includes(CHOICE_RESULT_KEYS.PROBABILITY);

  const isExistIfs = Object.keys(results[0].resultPropertyChipState).includes(CHOICE_RESULT_KEYS.REQUIRED_ITEMS);
  const clickToBranchFunc = event => {
    if (results.length === 1) {
      handleShowContextMenuClick(event);
      return;
    }

    if (isExistProb) {
      handleAddEmptyChoiceResultProbabilityClick();
    } else if (isExistIfs) {
      handleAddEmptyChoiceResultRquiredItemsClick();
    }
  };

  // useEffect(() => {
  //   const isExistProb = Object.keys(results[0].resultPropertyChipState).includes(CHOICE_RESULT_KEYS.PROBABILITY);
  //   const isExistIfs = Object.keys(results[0].resultPropertyChipState).includes(CHOICE_RESULT_KEYS.REQUIRED_ITEMS);
  //   if (isExistProb) {
  //     setBranch(CHOICE_RESULT_KEYS.PROBABILITY);
  //   } else if (isExistIfs) {
  //     setBranch(CHOICE_RESULT_KEYS.REQUIRED_ITEMS);
  //   } else {
  //     setBranch('');
  //   }
  // }, []);

  const showWarning = results.length >= 2;
  return (
    <AddingChoiceResultButtonContainer>
      <Button
        isTextOnly={false}
        backgroundColor="transparent"
        style={{ width: '32px', height: '32px', borderRadius: '50%', padding: '0' }}
        backgroundColorOnHover="#ffffff90"
        disabled={results?.length > 10}
        onClick={event => clickToBranchFunc(event)}
      >
        <AddResultIcon />
      </Button>
      {isContextMenuVisible && (
        <ContextMenu style={{ position: 'absolute', top: 36, right: 0 }}>
          <Item onClick={handleAddEmptyChoiceResultProbabilityClick}>
            <ContextMenuItemText>확률 기준</ContextMenuItemText>
          </Item>
          <Item onClick={handleAddEmptyChoiceResultRquiredItemsClick}>
            <ContextMenuItemText>보유한 아이템 기준</ContextMenuItemText>
          </Item>
          <ItemForTitle>
            <ContextMenuTitleText>분기 추가: 선택지당 기준 1개</ContextMenuTitleText>
          </ItemForTitle>
        </ContextMenu>
      )}

      {showWarning && (
        <HoverComponent
          label="기준을 변경하려면 기존 분기 (보라색)을 모두 삭제하세요."
          absolutes
          style={{ position: 'absolute', top: '8px', left: '-32px' }}
          iconColor={({ theme }) => theme.colors.ui_on_3}
          iconOpacity={0.8}
          align="center"
        />
      )}
    </AddingChoiceResultButtonContainer>
  );
};

const AddingChoiceResultButtonContainer = styled.div`
  position: absolute;
  width: 32px;
  height: 32px;
  right: 16px;
  bottom: 16px;
`;

const AddResultIcon = styled(BranchSVG)`
  width: 24px;
  height: 24px;
`;

const ContextMenuItemText = styled(TX.FootnoteM)`
  color: ${({ theme, disabled }) => (disabled ? theme.colors.danger : theme.colors.red)};
`;

const ContextMenuTitleText = styled(TX.Caption1)`
  color: ${({ theme }) => theme.colors.ui_on_1};
  line-height: 1.5;
  text-align: start;
`;

const ItemForTitle = styled.div`
  padding: 4px 2px 8px 8px;
  opacity: 0.5;
`;

export default React.memo(AddingChoiceResultButton);
